import ApiClient from "./ApiClient";
import FinancingRequestStatus from "../models/financing-request-status/FinancingRequestStatus";

export default class FinancingRequestStatusApiClient {
  apiClient: ApiClient;
  urlPrefix: string = "financing-request-statuses/";

  constructor() {
    this.apiClient = new ApiClient();
  }

  async getFinancingRequestStatuses() {
    const statuses = await this.apiClient.get(this.urlPrefix + 'admin-select');

    return statuses as Array<FinancingRequestStatus>;
  }
}
